import React, { useEffect, useState } from "react";
import { useGetAllSolutionApi } from "../../hooks/solution/useGetAllSolutionApi";
import { Button, Input, Modal, Table } from "antd";
import { useCreateSolutionApi } from "../../hooks/solution/useCreateSolutionApi";
import toast from "react-hot-toast";
import { useGetAllResultApi } from "../../hooks/result/useGetAllResultApi";
import { useCreateResultApi } from "../../hooks/result/useCreateResultApi";
import { FooterFilterMobile } from "../../components";

const ResultPage = () => {
  // state
  const [listRessult, setListRessult] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [typeResult, setTypeResult] = useState<any>();

  // api
  const { result } = useGetAllResultApi();
  const { mutate: $createNewResult } = useCreateResultApi();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    $createNewResult(
      {
        typeResult,
      },
      {
        onSuccess: () => {
          toast.success("Create new result success");
          setTypeResult("");
          setIsModalOpen(false);
          return;
        },
        onError: () => {
          toast.error("Create new result failure");
          setTypeResult("");
          setIsModalOpen(false);
          return;
        },
      }
    );
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (result) {
      const convertData = result?.data?.map((item: any, index: number) => {
        return {
          key: index,
          typeResult: item?.typeResult,
        };
      });
      setListRessult(convertData);
    }
  }, [result]);

  const columns = [
    {
      title: "Type Result",
      dataIndex: "typeResult",
      key: "typeResult",
    },
  ];

  return (
    <div>
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Create New Solution"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setTypeResult(e.target.value);
            }}
            placeholder="Type Result"
          />
        </div>
      </Modal>
      <div className="max-lg:px-[12px]">
        <div className="flex max-lg:mt-2 lg:items-center justify-between xl:mb-7 lg:mb-5 mb-4 max-lg:flex-col">
          <span className="uppercase xl:text-xl text-base font-semibold text-gray-600">
            MANAGE RESULT
          </span>
          <div>
            <Button
              onClick={showModal}
              color="default"
              variant="solid"
              size="middle"
            >
              CREATE RESULT
            </Button>
          </div>
        </div>
        <Table
          dataSource={listRessult}
          columns={columns}
          pagination={false}
        ></Table>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </div>
  );
};

export default ResultPage;
